import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { TournamentCategoryItemFragment, UnionFragment } from '@amf/shared/types/graphql';

import JoinTeamForm, { JoinTeamFormData } from 'components/join/JoinTeamForm';

const defaultValues: JoinTeamFormData = {
  teamName: '',
  managerName: '',
  email: '',
  phone: '',
  union: '',
  category: '',
};

interface JoinTeamSendProps {
  unions: UnionFragment[];
  categories: TournamentCategoryItemFragment[];
}

function JoinTeamSend({ unions, categories }: JoinTeamSendProps) {
  const { t } = useTranslate('malyfotbal');
  const [error, setError] = useState<Error | undefined>(undefined);
  const [success, setSuccess] = useState(false);

  const send = async (data: JoinTeamFormData) => {
    setError(undefined);
    setSuccess(false);

    const response = await fetch('/api/join/team', {
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const result = (await response.json()) as {
      success?: boolean;
      error?: string;
    };

    if (result.error) {
      setError(new Error(result.error));
      return;
    }

    if (result.success) {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <div className='Form Form--center'>
        <h2>{t('join.team.form.success.title')}</h2>
        <p className='Form__message'>{t('join.team.form.success.message')}</p>
      </div>
    );
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}>
      {error && <p>{error}</p>}
      <JoinTeamForm
        onSubmit={send}
        values={defaultValues}
        unions={unions}
        categories={categories}
      />
    </GoogleReCaptchaProvider>
  );
}

export default JoinTeamSend;
